import { VisibilityState } from '@tanstack/react-table';
import { useCallback, useRef } from 'react';
import { useLocalStorageState } from '../../../hooks/useLocalStorageState';

export function useColumnVisibility(key: string, defaultVisibility: VisibilityState) {
  const [columnVisibility, setColumnVisibility] = useLocalStorageState<VisibilityState>(
    key,
    defaultVisibility,
  );

  const handleResetColumnSizingRef = useRef<(() => void) | null>(null);

  const handleColumnVisibilityChange = useCallback((columnId: string, visible: boolean) => {
    setColumnVisibility((prev) => ({ ...prev, [columnId]: visible }));
  }, []);

  const handleResetColumns = useCallback(() => {
    setColumnVisibility(defaultVisibility);
    handleResetColumnSizingRef.current?.();
  }, [defaultVisibility, handleResetColumnSizingRef]);

  const setHandleResetColumnSizing = useCallback((handler: (() => void) | null) => {
    handleResetColumnSizingRef.current = handler;
  }, []);

  return {
    columnVisibility,
    handleColumnVisibilityChange,
    handleResetColumns,
    setHandleResetColumnSizing,
  };
}
